import { useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useSnapshot } from 'valtio';
import FeatureFlags, { type OrgFeatureFlag } from '~/authorizations/FeatureFlags';
import rootStore from '~/store';

export interface UseOrgFeatureFlagProps {
  flag: OrgFeatureFlag;
  redirectTo?: string;
}

export const useOrgFeatureFlag = ({ flag, redirectTo = '/' }: UseOrgFeatureFlagProps) => {
  const navigate = useNavigate();
  const { me, currentOrganizationId, currentOrganizationDetail } = useSnapshot(rootStore) as typeof rootStore;

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  return useEffect(() => {
    if (!currentOrganizationDetail.isLoading) {
      if (FeatureFlags.hasOrgFeatureFlag(flag)) {
        // do nothing, allowed to proceed
      } else {
        navigate({ to: redirectTo });
      }
    }
  }, [me?.id, currentOrganizationId, currentOrganizationDetail]);
};
